<template>
	<div id="parcel" class="d-flex flex-column vh-100" v-if="!loadError">
		<contentLoading :loading="!parcelLoaded"/>
		<contentTitle v-if="parcel" label="PARCEL" :close="routeClose">
			<h2 class="text-white font-weight-light mb-0">{{parcel | address}}</h2>
			<div class="text-light font-weight-light pb-2">{{parcelSub}}</div>

		</contentTitle>
		<contentModal v-if="mode !== null">
			<parcelSave v-if="mode === 'save'" :addressId="addressId" :parcel="parcel" @close="setMode(null)"></parcelSave>
			<share v-if="mode === 'share'" :link="location" @close="setMode(null)"></share>
		</contentModal>

		<contentBody v-if="parcel">
			<contentActions>
				<button class="btn btn-outline-light btn-sm" :class="{active:shareShown === true}" v-on:click="setMode('share')">
					<i class="material-icons md-18" title="center map on zoning">share</i> 
					Share
				</button>
				<button v-if="parcel.unlocked === true" title="parcel unlocked" class="btn btn-outline-light btn-sm">
					<i class="material-icons md-18">lock_open</i> 
					Unlocked
				</button>
				<button v-if="parcel.unlocked === false" v-on:click="unlock" title="unlock parcel" class="btn btn-outline-light btn-sm">
					<i class="material-icons md-18">lock</i> 
					Unlock
				</button>
				<button class="btn btn-outline-light btn-sm" title="center map on parcel" v-on:click="zoomTo(true)">
					<i class="material-icons md-18">place</i> 
					Center
				</button>
				<button class="btn btn-outline-light btn-sm" title="save this parcel to a collection" v-on:click="setMode('save')">
					<i v-if="isSaved" class="material-icons md-18">bookmark</i> 
					<i v-else class="material-icons md-18">bookmark_border</i> 
					Save
				</button>
			</contentActions>

			<div class="p-3 bg-white">
				<serviceInquiry 
					v-if="serviceCategory" 
					:parcel="parcel" 
					:handleBack="routeSelf"
					v-bind:categoryId="serviceCategory">
				</serviceInquiry>
				<serviceProvider 
					v-if="serviceCategory" 
					:parcel="parcel" 
					:handleBack="routeSelf"
					v-bind:categoryId="serviceCategory">
				</serviceProvider>
				<overview 
					v-if="tabActive == 'overview'" 
					:handleTab="handleTab || routeTab" 
					:handleBack="routeSelf"
					:parcel="parcel" 
				/>
				<zoning 
					v-else-if="tabActive == 'zoning'" 
					:handleBack="routeSelf"
					:parcel="parcel"
				/>
				<permits 
					v-else-if="tabActive == 'permits'" 
					:handleBack="routeSelf"
					:parcel="parcel"
				/>
				<exports 
					v-else-if="tabActive == 'exports'" 
					:handleBack="routeSelf"
					:parcel="parcel"
				/>
				<services 
					v-else-if="tabActive == 'services'" 
					:handleBack="routeSelf"
					:parcel="parcel">
				</services>
				<overlays 
					v-else-if="tabActive" 
					:handleBack="routeSelf"
					:category="tabActive"
					:parcel="parcel" 
				/>
			</div>
		</contentBody>
	</div>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentLoading from '../content/content-loading';
import contentModal from '../content/content-modal';
import contentTitle from '../content/content-title';
import share from '../content/content-share';

import overview from './parcel-overview';
import zoning from './parcel-zoning';
import overlays from './parcel-overlays';
import permits from './parcel-permits';
import exports from './parcel-exports';
import services from './parcel-services';
import serviceInquiry from './parcel-service-inquiry';
import serviceProvider from './parcel-service-provider';
import parcelSave from './parcel-save';

export default {
	name: 'parcel',

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentLoading,
		contentModal,
		contentTitle,
		share,
		overview,
		zoning,
		overlays,
		parcelSave,
		permits,
		exports,
		services,
		serviceInquiry,
		serviceProvider,
	},

	props:{
		// handleClose is an optional function that takes over the close functionality 
		handleClose: Function,
		// handleSelfRoute is an optional function that takes over the routing to the parcel
		handleSelfRoute: Function,
		// handleTab is an optional function that takes over the tab click routing
		handleTab: Function,
		// if no marker, no parcel marker will be presented
		noMarker: Boolean,
		// if no zoomTo, map will not zoom in to parcel
		noZoomTo: Boolean,
		// optional, the tab that is active
		tab: String,
		// required, the parcel id
		id: Number, 
	},

	computed: {
		isSaved: function(){
			return this.parcel.collections && this.parcel.collections.length > 0
		},
		parcel: function() {
			return this.$store.state.parcel.rec;
		},
		parcelTitle:function(){
			if (!this.parcel) return '';
			return this.$options.filters.address(this.parcel);
		},
		parcelSub:function(){
			if (!this.parcel) return '';
			let str = '',
				parcel = this.parcel;
			if (parcel.address){
				if (parcel.address.jurisdiction !== null) str += parcel.address.jurisdiction+', ';
				if (parcel.address.state !== null) str += parcel.address.state+' ';
				if (parcel.address.postal !== null) str += parcel.address.postal;
			}
			return str;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		location:function(){
			return window.location.href;
		},
		serviceCategory:function(){
			return this.$route.params.categoryId;
		},
		zoomToDone:function(){
			return this.$store.state.map.fitBoundsDone;
		}
	},

	created: function(){
		if (this.tab) this.$data.tabActive = this.tab;
		if (this.$route.query.addressId) this.$data.addressId = Number(this.$route.query.addressId);
		this.getRec();
		this.getDimensions();
	},
	data: function(){
		return {
			addressId:null,
			loadError:null,
			parcelLoaded:false,
			tabActive:'overview',
			shareShown:false,
			isMounted:false,
			tabsOverWidth:false,
			tabRightScroll:null,
			mode:null
		}
	},
	destroyed: function(){
		this.$store.dispatch('PARCEL_HIGHLIGHT_CLEAR',{});
		if (!this.noMarker) this.$store.dispatch('PARCEL_MARKER_CLEAR');
		this.$store.dispatch('PARCEL_DIMENSIONS_CLEAR');
	},
	methods: {
		collect:function(){
			this.$store.dispatch('PARCEL_COLLECT', {
				id: this.id
			});	
		},
		getDimensions: function(){
			this.$store.dispatch('PARCEL_GET_DIMENSIONS', {
				id: this.id,
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		getRec: function(){
			this.loadError = null;
			this.$store.dispatch('PARCEL_GET', {
				id: this.id,
				addressId: this.$data.addressId
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		unlock: function(){
			this.$router.push({
				name: 'unlock-parcel', 
				params:{
					id: this.id
				},
				query:{
					addressId: this.addressId
				}
			});
		},
		highlight: function(){
			this.$store.dispatch('PARCEL_HIGHLIGHT', {});
		},
		zoomTo: function(force){
			if (!this.noZoomTo || force) this.$store.dispatch('PARCEL_ZOOM_TO', {});
		},
		checkInside:function(){
			const bbox = this.parcel.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom > 22 || this.mapZoom <= 16) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.parcel || !this.parcelLoaded || !this.mapLoaded || !this.isMounted) return;
			this.ready();
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else this.highlight();

			this.updateTitleTag();
		},
		routeClose:function(){
			if (this.handleClose) return this.handleClose()
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeSelf: function(){
			if (this.handleSelfRoute) return this.handleSelfRoute()
			this.$router.push({
				name:'parcels',
				params:{
					id:this.id
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		routeTab:function(tab){
			this.shareShown = false;
			this.$router.push({
				name:'parcels-tab',
				params:{
					id:this.id,
					tab:tab
				},
				query:{
					addressId:this.$data.addressId
				}
			});
		},
		updateTitleTag:function(){
			document.title = this.parcelTitle+' - Scoutred Maps';
		},
		setMode:function(mode){
			this.mode = mode
		},
		share:function(){
			if (this.shareShown){
				this.shareShown = false;
				return;
			}
			if (navigator.share){
				navigator.share({
				  title: this.parcelTitle+' - Scoutred Maps',
				  text: 'Parcel data including zoning and owner\'s information for '+this.parcelTitle,
				  url: window.location.href,
				});
				return;
			}

			this.shareShown = true;
		}
	},
	mounted:function(){
		this.isMounted = true;
		this.checkReady();
	},

	watch: {
		id: function(newId, oldId){
			if (newId === oldId) return

			this.$data.parcelLoaded = false;
			if (!this.noMarker) this.$store.dispatch('PARCEL_MARKER_CLEAR');
			this.getRec();
			this.getDimensions();	
		},
		$route:function(toRoute, fromRoute){
			if (toRoute.query.addressId) this.addressId = Number(toRoute.query.addressId);

			if (toRoute.params.map !== fromRoute.params.map){
				if (toRoute.params.map){
					const zoom = this.$store.getters.mapZoomGet();
					if (zoom < 16){
						if (!this.noMarker) this.$store.dispatch('PARCEL_MARKER');
					} else {
						this.$store.dispatch('PARCEL_HIGHLIGHT');
						if (!this.noMarker) this.$store.dispatch('PARCEL_MARKER_CLEAR');
					}
				}
			}
			if (toRoute.params.tab && this.$data.tabActive !== toRoute.params.tab){
				this.$data.tabActive = toRoute.params.tab;
				if (toRoute.params.tab) this.$store.dispatch('SCROLL_CONTENT_TOP');
			}
			if (!toRoute.params.tab && this.$data.tabActive !== toRoute.params.tab){
				this.$data.tabActive = 'overview';
				if (toRoute.params.tab) this.$store.dispatch('SCROLL_CONTENT_TOP');
			}
		},
		parcel:function(newParcel,oldParcel){
			if (!newParcel) return;
			this.$data.parcelLoaded = true;
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		},
		zoomToDone:function(){
			this.highlight();
		}
	}
}

</script>

<style>

.lock-block{
	margin-bottom:1rem;
	background-color:#37474F;
	cursor:pointer;
	overflow:hidden;
	border-radius:4px;
	color:#FFF;
}
.lock-block:hover{
	background-color:#273237;
}
.lock-icon-box{
	width:25%;
	float:left;
	text-align:right;
	line-height:65px;
	padding-right:20px;
}
.lock-text{
	width:75%;
	float:left;
	padding:1rem 1rem 1rem 0;
}

.title-nav{
	margin:0 0 1rem 0;
	padding:0;
}
.title-nav li{
	border-bottom:1px solid #EFEFEF;
	line-height:2.5rem;
	list-style-type:none;
	font-size:0.8rem;
	opacity:1;
	position:relative;
	padding-right:18px;
}
.title-nav li .back-btn i{
	position:relative;
	top:-2px;
	margin:0;
}
.title-nav i{
	position:relative;
	top:-1px;
	margin-right:4px;
}
.title-nav .back-btn{
	width:44px;
	height:44px;
	position:absolute;
	line-height:44px;
	left:-14px;
	top:-1px;
	text-align:center;
	cursor:pointer;
}
.title-nav .back-btn:hover{
	color:#0687D1;
}
.title-nav .title-label{
	padding-left:24px;
}

.line-height-locked{
	line-height:70px;
}
.mt-updated{
	margin-top:3px;
}
.parcel-options i{
	cursor:pointer;
	color:#868e96;
}
.parcel-options i:hover{
	color:#FFFFFF;
}
.parcel-options i.green{
	color:#679E38;
}
.parcel-options i.green:hover{
	color:#7CB341;
}
.nav-link{
	cursor:pointer;
	color:#CCC;
}
.nav-link:hover{
	color:#EEE;
}

#parcel h3{
	font-size:1.2rem;
	line-height:1.2;
	margin:0.5rem 0;
}

#parcel .field-row{
	font-size:14px;
	line-height:24px;
	background-color:#EFEFEF;
}
#parcel .nav-tabs{
	white-space: nowrap; 
	display: flex;
	flex-direction: row; 
	flex-wrap:nowrap;
}
.nav-container{
	margin-bottom:-1px;
	position:relative;
}

#parcel .updated-text{
	font-size:0.7rem;
	color:#6c757d;
	float:right;
	vertical-align:bottom;
	font-weight:200;

}

</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel.vue